(function(){
  const money=(cents,currency)=>{
    try{return new Intl.NumberFormat(undefined,{style:'currency',currency:currency||'USD'}).format((Number(cents)||0)/100)}
    catch(e){return '$'+((Number(cents)||0)/100).toFixed(2)}
  };

  const variantNote=(title)=>{
    const v=String(title||'').toLowerCase();
    if(v.includes('standard')) return 'Beautiful as shown';
    if(v.includes('deluxe')) return 'More flowers + fuller design';
    if(v.includes('premium')) return 'Largest, fullest presentation';
    return '';
  };

  function updateDeliveryMessages(){
      let hour=0,day='';
      try{
        const parts=new Intl.DateTimeFormat('en-US',{timeZone:'America/New_York',hour:'numeric',hour12:false,weekday:'short'}).formatToParts(new Date());
        hour=Number(parts.find(p=>p.type==='hour')?.value||0);
        day=parts.find(p=>p.type==='weekday')?.value||'';
      }catch(e){}
    document.querySelectorAll('[data-fmf-delivery-message]').forEach(el=>{
        const cutoff=Number(el.dataset.cutoff||14);
        const effective=day==='Sun'?Math.min(cutoff,13):cutoff;
        const before=hour<effective;
        const clock=(effective>12?effective-12:effective)+' PM';
        const format=el.dataset.fmfDeliveryFormat||el.dataset.deliveryFormat||'full';
        let text='';
        if(format==='top') text=before?`SAME-DAY MIAMI DELIVERY • ORDER BY ${clock}`:'MIAMI FLOWER DELIVERY • NEXT AVAILABLE';
        else if(format==='product') text='✓ Order now for delivery same day';
        else if(format==='compact') text=before?'✓ Same-Day Delivery':'✓ Next-Day Delivery Available';
        else if(format==='badge') text=before?'Same day':'Fresh delivery';
        else if(format==='meta') text=before?`Order by ${clock}`:'Next available delivery';
        else text=before?`✓ Order by ${clock} for Same-Day Miami Delivery`:'✓ Order now for the same day Miami delivery';
      if(el.textContent!==text) el.textContent=text;
    });
  }

  function initDeliveryMessages(){
    updateDeliveryMessages();
    window.setInterval(updateDeliveryMessages,60000);
  }

  function initStickyATC(){
    const bar=document.querySelector('.fmf-sticky-atc');
    if(!bar) return;
    const scope=bar.closest('.product__info-container')||document;
    const getOriginal=()=>scope.querySelector('product-form .product-form__submit')||document.querySelector('product-form .product-form__submit, .product-form__submit');
    const button=bar.querySelector('.fmf-sticky-atc__button');
    const price=bar.querySelector('.fmf-sticky-atc__price');
    const title=bar.querySelector('.fmf-sticky-atc__title');
    if(!getOriginal()||!button) return;

    const updateVisibility=()=>{
      const original=getOriginal();
      if(!original){bar.classList.remove('is-visible');return}
      const rect=original.getBoundingClientRect();
      bar.classList.toggle('is-visible',rect.bottom<0);
    };
    window.addEventListener('scroll',updateVisibility,{passive:true});
    window.addEventListener('resize',updateVisibility,{passive:true});

    button.addEventListener('click',()=>{
      const original=getOriginal();
      if(original&&!original.disabled&&original.getAttribute('aria-disabled')!=='true') original.click();
    });
    const sync=()=>{
      const original=getOriginal();
      if(!original){bar.classList.remove('is-visible');return}
      button.disabled=original.disabled||original.getAttribute('aria-disabled')==='true';
      const current=document.querySelector('[id^="price-"] .price-item--sale:not(.price-item--regular), [id^="price-"] .price-item--regular');
      if(current&&price) price.textContent=current.textContent.trim();
      if(title){
        const selected=[...document.querySelectorAll('variant-selects input[type="radio"]:checked')].map(i=>i.value).filter(Boolean);
        title.textContent=selected.length?selected.join(' / '):'Ready to order';
      }
      updateVisibility();
    };
    document.addEventListener('change',()=>setTimeout(sync,80));
    sync();
  }

  function initProductVariantCards(){
    const node=document.querySelector('[data-fmf-product-json]');
    if(!node) return;
    let product;
    try{product=JSON.parse(node.textContent)}catch(e){return}
    if(Number(product.option_count)!==1) return;
    document.querySelectorAll('variant-selects .product-form__input--pill input[type="radio"]').forEach(input=>{
      const variant=(product.variants||[]).find(v=>Array.isArray(v.options)&&v.options[0]===input.value);
      const label=document.querySelector(`label[for="${CSS.escape(input.id)}"]`);
      if(!variant||!label||label.querySelector('.fmf-variant-price')) return;
      const span=document.createElement('span');
      span.className='fmf-variant-price';
      span.textContent=money(variant.price,product.currency);
      label.appendChild(span);
    });
  }

  async function addVariantToCart(variantId,trigger){
    const cart=document.querySelector('cart-notification')||document.querySelector('cart-drawer');
    const formData=new FormData();
    formData.append('id',String(variantId));
    formData.append('quantity','1');
    if(cart&&typeof cart.getSectionsToRender==='function'){
      formData.append('sections',cart.getSectionsToRender().map(section=>section.id).join(','));
      formData.append('sections_url',window.location.pathname);
      if(typeof cart.setActiveElement==='function'&&trigger) cart.setActiveElement(trigger);
    }
    const res=await fetch(window.routes?.cart_add_url||'/cart/add.js',{
      method:'POST',
      headers:{'X-Requested-With':'XMLHttpRequest','Accept':'application/json'},
      body:formData
    });
    const response=await res.json();
    if(!res.ok||response.status) throw new Error(response.description||response.message||'Unable to add item');
    if(cart&&response.sections&&typeof cart.renderContents==='function'){
      cart.renderContents(response);
      window.setTimeout(updateDeliveryMessages,80);
    }else{
      const bubble=document.querySelector('#cart-icon-bubble');
      const cartData=await fetch('/cart.js',{headers:{Accept:'application/json'}}).then(r=>r.json()).catch(()=>null);
      if(bubble&&cartData){
        let count=bubble.querySelector('.cart-count-bubble span[aria-hidden="true"], .cart-count-bubble span');
        if(count) count.textContent=cartData.item_count;
        else if(cartData.item_count>0) bubble.insertAdjacentHTML('beforeend','<div class="cart-count-bubble"><span aria-hidden="true">'+cartData.item_count+'</span></div>');
      }
    }
    document.dispatchEvent(new CustomEvent('fmf:cart-added',{bubbles:true,detail:{variantId:Number(variantId)}}));
    return response;
  }

  function productJsonUrl(productUrl){
    const u=new URL(productUrl,window.location.origin);
    u.pathname=u.pathname.replace(/\/$/,'')+'.js';
    return u.toString();
  }

  function ensureQuickSheet(){
    let sheet=document.querySelector('.fmf-quick-sheet');
    if(sheet) return sheet;
    sheet=document.createElement('div');
    sheet.className='fmf-quick-sheet';
    sheet.setAttribute('aria-hidden','true');
    sheet.innerHTML=`
      <div class="fmf-quick-sheet__backdrop" data-fmf-sheet-close></div>
      <div class="fmf-quick-sheet__panel" role="dialog" aria-modal="true" aria-label="Choose flower options">
        <div class="fmf-quick-sheet__handle"></div>
        <button class="fmf-quick-sheet__close" type="button" aria-label="Close" data-fmf-sheet-close>×</button>
        <div data-fmf-sheet-content></div>
      </div>`;
    document.body.appendChild(sheet);
    sheet.addEventListener('click',e=>{if(e.target.closest('[data-fmf-sheet-close]')) closeQuickSheet(sheet)});
    document.addEventListener('keydown',e=>{if(e.key==='Escape'&&sheet.classList.contains('is-open')) closeQuickSheet(sheet)});
    return sheet;
  }

  function closeQuickSheet(sheet){
    sheet.classList.remove('is-open');
    sheet.setAttribute('aria-hidden','true');
    document.body.classList.remove('overflow-hidden');
  }

  async function openQuickSheet(btn){
    const sheet=ensureQuickSheet();
    const content=sheet.querySelector('[data-fmf-sheet-content]');
    content.innerHTML='<p style="padding:18px 4px">Loading options…</p>';
    sheet.classList.add('is-open');
    sheet.setAttribute('aria-hidden','false');
    document.body.classList.add('overflow-hidden');
    try{
      const product=await fetch(productJsonUrl(btn.dataset.productUrl),{headers:{Accept:'application/json'}}).then(r=>{if(!r.ok) throw new Error('Unable to load options'); return r.json()});
      const variants=(product.variants||[]);
      let selected=variants.find(v=>v.available)||variants[0];
      const image=product.featured_image||product.images?.[0]||'';
      const noteFor=(v)=>variantNote(v.title);
      content.innerHTML=`
        <div class="fmf-quick-sheet__head">
          ${image?`<img class="fmf-quick-sheet__image" src="${image}" alt="">`:''}
          <div><h2 class="fmf-quick-sheet__title">${escapeHtml(product.title||'Choose options')}</h2><p class="fmf-quick-sheet__prompt">Choose the size you’d like.</p></div>
        </div>
        <div class="fmf-quick-sheet__variants">
          ${variants.map(v=>`<button type="button" class="fmf-quick-sheet__variant${selected&&v.id===selected.id?' is-selected':''}" data-fmf-sheet-variant="${v.id}" ${v.available?'':'disabled'}><span><span class="fmf-quick-sheet__variant-name">${escapeHtml(v.title)}</span>${noteFor(v)?`<span class="fmf-quick-sheet__variant-note">${escapeHtml(noteFor(v))}</span>`:''}</span><span class="fmf-quick-sheet__variant-price">${money(v.price,window.Shopify?.currency?.active||'USD')}</span></button>`).join('')}
        </div>
        <button class="fmf-quick-sheet__add" type="button" data-fmf-sheet-add ${selected?'':'disabled'}>Add to cart${selected?' • '+money(selected.price,window.Shopify?.currency?.active||'USD'):''}</button>`;
      content.querySelectorAll('[data-fmf-sheet-variant]').forEach(vbtn=>vbtn.addEventListener('click',()=>{
        selected=variants.find(v=>String(v.id)===vbtn.dataset.fmfSheetVariant);
        content.querySelectorAll('[data-fmf-sheet-variant]').forEach(x=>x.classList.toggle('is-selected',x===vbtn));
        const add=content.querySelector('[data-fmf-sheet-add]');
        add.disabled=!selected;
        add.textContent=selected?'Add to cart • '+money(selected.price,window.Shopify?.currency?.active||'USD'):'Add to cart';
      }));
      const add=content.querySelector('[data-fmf-sheet-add]');
      add.addEventListener('click',async()=>{
        if(!selected||add.disabled) return;
        const old=add.textContent; add.disabled=true; add.textContent='Adding…';
        try{await addVariantToCart(selected.id,btn); closeQuickSheet(sheet)}
        catch(e){add.disabled=false;add.textContent=old;alert(e.message||'Unable to add this item. Please try again.')}
      });
    }catch(e){
      content.innerHTML=`<p style="padding:18px 4px">We couldn’t load the options. <a href="${btn.dataset.productUrl}">Open the product page</a>.</p>`;
    }
  }

  function escapeHtml(str){
    return String(str??'').replace(/[&<>'"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]));
  }

  function initQuickAdds(){
    document.addEventListener('click',async e=>{
      const btn=e.target.closest('[data-fmf-quick-add]');
      if(!btn||btn.disabled) return;
      e.preventDefault();
      const id=btn.dataset.variantId;
      if(!id){
        if(btn.dataset.productUrl&&window.matchMedia('(min-width:750px)').matches){window.location.href=btn.dataset.productUrl;return}
        if(btn.dataset.productUrl) openQuickSheet(btn);
        return;
      }
      const old=btn.textContent;
      btn.disabled=true;btn.textContent='Adding…';
      try{
        await addVariantToCart(id,btn);
        btn.textContent='Added ✓';
        setTimeout(()=>{if(document.body.contains(btn)){btn.textContent=old;btn.disabled=false}},1100);
      }catch(e2){
        btn.textContent='Try again';btn.disabled=false;
        setTimeout(()=>{if(document.body.contains(btn)) btn.textContent=old},1400);
      }
    });
  }

  function saveViewedProduct(){
    const node=document.querySelector('[data-fmf-product-json]');
    if(!node) return;
    try{
      const p=JSON.parse(node.textContent);
      let items=JSON.parse(localStorage.getItem('fmfRecentlyViewed')||'[]');
      items=items.filter(x=>x.handle!==p.handle);
      items.unshift({handle:p.handle,title:p.title,url:p.url,image:p.image});
      localStorage.setItem('fmfRecentlyViewed',JSON.stringify(items.slice(0,8)));
    }catch(e){}
  }

  function renderRecentlyViewed(){
    const wrap=document.querySelector('[data-fmf-recently-viewed]');
    if(!wrap) return;
    let items=[];try{items=JSON.parse(localStorage.getItem('fmfRecentlyViewed')||'[]')}catch(e){}
    if(items.length<2) return;
    const grid=wrap.querySelector('.fmf-rv-grid');if(!grid) return;
    grid.innerHTML=items.slice(0,6).map(p=>`<a class="fmf-rv-item" href="${p.url}"><img src="${p.image}" loading="lazy" alt=""><span>${escapeHtml(p.title)}</span></a>`).join('');
    wrap.classList.add('is-active');
  }

  function initEndcapProtection(){
    const endcap=document.querySelector('.fmf-endcap');
    if(!endcap||!('IntersectionObserver' in window)) return;
    new IntersectionObserver(entries=>{
      entries.forEach(entry=>document.body.classList.toggle('fmf-at-end',entry.isIntersecting));
    },{threshold:.15}).observe(endcap);
  }

  document.addEventListener('DOMContentLoaded',()=>{
    initDeliveryMessages();
    initStickyATC();
    initProductVariantCards();
    initQuickAdds();
    saveViewedProduct();
    renderRecentlyViewed();
    initEndcapProtection();
  });
})();
